// ./src/locales/translations/ptBR.ts
const ptBR = {
  // language: 'pt-BR',
  Home2: {
    sidebar: {
      assistance: 'Home',
      our_plans: 'Nossos planos',
      to_partners: 'Para parceiros',
      to_providers: 'Para prestadores',
      customer_area: 'Área do cliente',
    },
    header: {
      assistance: 'Home',
      our_plans: 'Nossos planos',
      to_partners: 'Para afiliados',
      to_providers: 'Para prestadores',
      customer_area: 'Área do cliente',
    },
    assistance: {
      title: 'Assistência veicular 24h por dia',
      subtitle: 'Estamos aqui para te ajudar. Do que você precisa?',
    },
    cards_options: {
      winch: 'Guincho',
      tire_change: 'Troca de pneu',
      battery_recharge: 'Recarga de bateria',
      locksmith: 'Chaveiro',
      fuel: 'Combustível',
      mechanical_relief: 'Socorro mecânico',
    },
    contacts: {
      or_call: 'ou ligue',
      number_telephone: '0800 100 1100',
      app_android_ios: 'app android e IOS',
      download_now: 'Baixe agora',
    },
    footer: {
      terms: 'Termos de uso e políticas de privacidade',
      contact_us: 'Fale conosco',
    },
  },
};

export default ptBR;
